<template functional>
  <img
      :src="require('@/assets/images/ajax-loader.gif')"
      width="160" height="20" alt="Loading..."
      :class="[
          'insights-loading',
          props.centered ? 'centered' : '',
          data.class,
          data.staticClass
        ]"
      :style="[
           data.style,
           data.staticStyle
       ]"
  >
</template>

<script>
export default {
  name: 'InsightsLoading',
  props: {
    centered: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="postcss">
.insights-loading {
  @apply mx-auto py-4;
  &.centered {
    @apply absolute top-0 left-0 right-0 bottom-0 my-auto;
  }
}
</style>